module.exports = __webpack_public_path__ + "img/GAME_CROSSTURTLE.dbfa27b5.png";